import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGenerateKeyController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGenerateKeyController.php
* @route '/api/company/{company}/elys/generate-key'
*/
const ElysGenerateKeyController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGenerateKeyController.url(args, options),
    method: 'get',
})

ElysGenerateKeyController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/elys/generate-key',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGenerateKeyController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGenerateKeyController.php
* @route '/api/company/{company}/elys/generate-key'
*/
ElysGenerateKeyController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return ElysGenerateKeyController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGenerateKeyController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGenerateKeyController.php
* @route '/api/company/{company}/elys/generate-key'
*/
ElysGenerateKeyController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGenerateKeyController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGenerateKeyController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGenerateKeyController.php
* @route '/api/company/{company}/elys/generate-key'
*/
ElysGenerateKeyController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysGenerateKeyController.url(args, options),
    method: 'head',
})

export default ElysGenerateKeyController